import { Paginated } from '../../adl-gen/common';
import { DbKey, WithDbId } from '../../adl-gen/common/db';
import { TableQuery } from '../../adl-gen/common/tabular';
import { Auth0SamlConnection } from '../../adl-gen/totalinteraction/futurefit/db';
import { Service } from '../../service/service';
import { LoggedIn, LoggedInSuper } from '../../stores/identity-store';

import { DataStore, TransportLayer } from './datastore';

class SamlConnectionApi implements TransportLayer<Auth0SamlConnection> {
  kind: string = 'Auth0SamlConnection';
  constructor(protected readonly service: Service) {}
  create = async (item: Auth0SamlConnection): Promise<DbKey<Auth0SamlConnection>> =>
    this.service.createAuth0SamlConnection(item);
  update = async (itemWithId: WithDbId<Auth0SamlConnection>): Promise<void> =>
    this.service.updateAuth0SamlConnection(itemWithId);
  doDelete = async (id: DbKey<Auth0SamlConnection>): Promise<void> => this.service.deleteAuth0SamlConnection(id);
  query = async (q: TableQuery): Promise<Paginated<WithDbId<Auth0SamlConnection>>> =>
    this.service.queryAuth0SamlConnections(q);
}

export class Auth0SamlConnectionStore extends DataStore<Auth0SamlConnection> {
  static fromService = (
    service: Service,
    identity: LoggedIn | LoggedInSuper,
    id?: DbKey<Auth0SamlConnection>
  ): Auth0SamlConnectionStore => {
    const store = new Auth0SamlConnectionStore(new SamlConnectionApi(service), identity, id);
    return store;
  };
}



// WEBPACK FOOTER //
// ./src/admin/stores/saml-connection-store.ts